import { render, staticRenderFns } from "./CharactersFeats.vue?vue&type=template&id=eaa8744a&lang=pug&"
import script from "./CharactersFeats.vue?vue&type=script&lang=ts&"
export * from "./CharactersFeats.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports